import { render, staticRenderFns } from "./GrossPrice.vue?vue&type=template&id=67978dca&"
import script from "./GrossPrice.vue?vue&type=script&lang=js&"
export * from "./GrossPrice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports